import { put, call, fork, takeLatest, takeLeading, select } from 'redux-saga/effects';

import {
    LandingPageSkipSubdomainLoading,
    LandingPageSubdomainError,
    LandingPageSubdomainSuccess,
} from '@/store/landingPageSubdomain/actions';
import {
    addLandingPageAccountSubdomainApi,
    addLandingPageSubdomainApi,
    getLandingPageSubdomainApi,
    updateLandingPageAccountSubdomainApi,
    updateLandingPageSubdomainApi,
} from '@/services/ApiCategories/landings';
import { getAccountAccessLevel } from '@/store/account/actions';
import { AccessLevel } from '@dev/ee-api/ee-api-models';
import {
    ActionTypes,
    AddLandingPageSubdomainAction,
    LandingPageSubdomainModel,
    LoadLandingPageSubdomainAction,
    UpdateLandingPageSubdomainAction,
} from '../store/landingPageSubdomain/types';
import { errorToast } from './commonGenerators/errorToast';

function* addSubdomainToLandingPage({
    type,
    payload,
    meta,
}: AddLandingPageSubdomainAction | UpdateLandingPageSubdomainAction): any {
    const callFn = {
        [ActionTypes.UPDATE_LANDING_PAGE_SUBDOMAIN]: updateLandingPageSubdomainApi,
        [ActionTypes.ADD_LANDING_PAGE_SUBDOMAIN]: addLandingPageSubdomainApi,
    } as any;

    try {
        const result = yield call(callFn[type], payload);

        yield put(LandingPageSubdomainSuccess(result, meta));
    } catch (e) {
        const msgID = e?.response?.data?.MessageID || '';

        yield put(LandingPageSubdomainError(meta, msgID));
        !msgID && (yield call(errorToast, e));
    }
}
function* addSubdomainToAccount({
    type,
    payload,
    meta,
}: AddLandingPageSubdomainAction | UpdateLandingPageSubdomainAction): any {
    const callFn = {
        [ActionTypes.UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN]: updateLandingPageAccountSubdomainApi,
        [ActionTypes.ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN]: addLandingPageAccountSubdomainApi,
    } as any;

    try {
        const result = yield call(callFn[type], payload);

        yield put(LandingPageSubdomainSuccess(result, meta));
    } catch (e) {
        const msgID = e?.response?.data?.MessageID || '';

        yield put(LandingPageSubdomainError(meta, msgID));
        !msgID && (yield call(errorToast, e));
    }
}
function* getSubdomainForAccount({ payload }: LoadLandingPageSubdomainAction): any {
    try {
        const accountAccessLevel = yield select(getAccountAccessLevel);

        if (!accountAccessLevel.includes(AccessLevel.ViewLandingPages)) {
            yield put(LandingPageSkipSubdomainLoading());
            return;
        }

        const subdomain: LandingPageSubdomainModel = yield call(getLandingPageSubdomainApi, payload.landingPageId);

        yield put(LandingPageSubdomainSuccess(subdomain));
    } catch (e) {
        yield call(errorToast, e);
    }
}

function* watchUpload(): any {
    yield takeLatest(
        [ActionTypes.ADD_LANDING_PAGE_SUBDOMAIN, ActionTypes.UPDATE_LANDING_PAGE_SUBDOMAIN],
        addSubdomainToLandingPage
    );
    yield takeLatest(
        [ActionTypes.ADD_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN, ActionTypes.UPDATE_LANDING_PAGE_TO_ACCOUNT_SUBDOMAIN],
        addSubdomainToAccount
    );
    yield takeLeading([ActionTypes.GET_LANDING_PAGE_SUBDOMAIN], getSubdomainForAccount);
}

const landingPageSubdomainSagas = [fork(watchUpload)];

export default landingPageSubdomainSagas;
